import { _ as s } from "./index970.mjs";
import { i as a } from "./index597.mjs";
var e = s, o = a, t = Object.prototype, n = t.hasOwnProperty, i = t.propertyIsEnumerable, m = e(/* @__PURE__ */ function() {
  return arguments;
}()) ? e : function(r) {
  return o(r) && n.call(r, "callee") && !i.call(r, "callee");
}, u = m;
export {
  u as i
};
